import cx from 'classnames';
import { ReactNode } from 'react';

import styles from './cardListItem.module.scss';

export const CardListItem = ({ className, children }: { children: ReactNode; className?: string }) => {
  return <li className={cx(styles.wrapper, className)}>{children}</li>;
};
